module.exports = __webpack_public_path__ + "img/CM-AB-25-INFINITI-Playful.a4b95b4f.jpg";